import AppService from './AppService';
const serverHost = AppService.serverHost();
console.log('serverHost', serverHost);
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

const apolloClient = new ApolloClient({
  name: 'aperza-web',
  connectToDevTools: true,
  cache: new InMemoryCache(),
  link: new HttpLink({
    uri:  `${serverHost}/graphql`,
    credentials: 'include',
    headers: {
      'Aperza-App': 'aperza-web',
    }
  })
});

export {
  apolloClient
}

